module.exports = __webpack_public_path__ + "img/comision-2.60b24816.jpg";